export class ToastConstants {
  // public static CRUD_CONSTANT = '{0} {1} successfully';
}
